// src/services/authService.ts
import apiClient from '../config/api';

interface LoginResponse {
  token?: string;
  user?: {
    id: string;
    name: string;
    email: string;
  }; // Replace or expand based on your actual user schema
}

interface AuthStatusResponse {
  authenticated: boolean;
}

class AuthService {
  static async login(password: string): Promise<LoginResponse> {
    try {
      const response = await apiClient.post<LoginResponse>('/auth/login', { password });
      localStorage.setItem('auth_status', 'authenticated');
      return response.data;
    } catch (error) {
      localStorage.removeItem('auth_status');
      throw error;
    }
  }

  static async logout(): Promise<void> {
    try {
      await apiClient.post('/auth/logout');
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      localStorage.removeItem('auth_status');
    }
  }

  static async checkAuthStatus(): Promise<boolean> {
    try {
      const response = await apiClient.get<AuthStatusResponse>('/auth/status');
      const isAuthenticated = response.data.authenticated;

      if (isAuthenticated) {
        localStorage.setItem('auth_status', 'authenticated');
      } else {
        localStorage.removeItem('auth_status');
      }

      return isAuthenticated;
    } catch {
      localStorage.removeItem('auth_status');
      return false;
    }
  }

  static isAuthenticated(): boolean {
    return localStorage.getItem('auth_status') === 'authenticated';
  }
}

export default AuthService;
